import { render } from "./Otp.vue?vue&type=template&id=cb40d8be&scoped=true"
import script from "./Otp.vue?vue&type=script&lang=js"
export * from "./Otp.vue?vue&type=script&lang=js"

import "./Otp.vue?vue&type=style&index=0&id=cb40d8be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb40d8be"]])

export default __exports__